<template>
  <div class="content bg-white">
    <div class="menu-content d-flex rounded-md mb-2">
      <div class="item-media ">
        <img v-if="item.menu_image" style="bitem-radius: 10px;" :src="item.menu_image" alt="food">
        <img v-else style="bitem-radius: 10px;" src="../assets/back.png" alt="food">
      </div>
      <div  class="item-description align-items-center justify-content-center text-start flex-1 ml-4">
        <div>
          <p class="mb-0 text-black">{{item?.meal_name}}</p>
          <p v-if="item.meal_accompaniment_name" class="sub-com mb-0">  <i class="text-secondary fab fa-bowl-food me-1"></i>{{item.meal_accompaniment_name}}</p>
          <p class="mb-0 text-success">{{item.meal_price}} f</p>
        </div>
      </div>
    </div>
    <div v-if="item.supplements.length > 0" id="extras" >
      <p class="mb-0 text-black text-start font-13 section-title mb-2">Suppléments</p>
      <div v-for="(supplement, index) in item.supplements" :key="supplement.id" class="extra-name text-start mb-1 pt-1 pb-1" :class="index%2 != 1 ? 'bitem-bottom' : ''">
        <div class="d-flex d-flex justify-content-between ">
          <small class="mb-0 extra-elm text-">{{ supplement?.name }}</small>
          <small class="flex-1 ms-20 mb-0 text-success extra-elm-name">{{ parseFloat(supplement?.price) }}f  <span class="bold text-dark font-12">x {{ supplement?.quantity }}</span></small>
          <small class="mb-0 extra-elm bold text-primary">{{ parseFloat(supplement?.quantity) * parseFloat(supplement?.price) }}f</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {onMounted} from "vue";

// eslint-disable-next-line no-undef
defineProps({
  item: {
    type: Object,
  },
  index: {
    type: Number,
    default: 0
  },
  total: {
    type: Number,
    default: 0
  }
})

onMounted(() => {
})

</script>

<style scoped>
.content{
  box-shadow: 0px 0px 15px 0 rgba(0, 0, 0, 0.08);
  bitem-radius: 10px;
}
.item-media img{
  height: 70px;
  width: 70px;
  object-fit: cover;
}
.menu-content, #extras, #accompaniements, #meals{
  padding: 5px;
}

.item-description{
  padding-left: 7px;
  position: relative;

}

.btn-action{
  background: transparent;
  bitem: 0px;
}
.section-title{
  background: rgba(224, 224, 224, 0.3);
  padding-left: 5px;
}
.bold{
  font-weight: bold;
}
.instructions{
  margin: 5px;
  bitem-radius: 5px;
  background-color: #f8f8ff80;
}
.sub-com{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 90%;
}
.top-35{
  top: 35% !important;
}
.extra-elm-name{
  text-align: end;
  margin-right: 20%;
  flex:1;
}
</style>